import { EllipsisVertical } from 'lucide-react';
import { Dropdown, DropdownContent, DropdownItem, DropdownTrigger } from '@waymail/ui';
import type { Pasta } from '../lib/api';
import { ehDeSistema } from '../lib/pastas';

/*
 * Fora de `GerenciarPastas` porque a barra lateral carrega de cara: com o menu
 * la dentro, a tela inteira de gestao de pastas entrava no bundle inicial. O
 * dialogo mora em `DialogoDePasta` e e carregado so quando abre.
 */

/** O que a tela pediu: criar (com a pai sugerida), renomear, mover ou excluir. */
export type PedidoDePasta =
  | { tipo: 'criar'; paiId: string | null }
  | { tipo: 'renomear'; pasta: Pasta }
  | { tipo: 'mover'; pasta: Pasta }
  | { tipo: 'excluir'; pasta: Pasta };

/**
 * Os itens do menu de uma pasta. Compartilhados entre o botao de tres pontos e
 * o menu de contexto (botao direito), para os dois nunca divergirem - nem no
 * respeito as pastas de sistema, que nao se renomeiam, movem nem excluem.
 */
export function ItensDaPasta({
  pasta,
  onPedir,
  onAbrir,
}: {
  pasta: Pasta;
  onPedir: (p: PedidoDePasta) => void;
  /** So o menu de contexto abre a pasta; no botao de tres pontos ela ja esta ao lado. */
  onAbrir?: () => void;
}) {
  const sistema = ehDeSistema(pasta);
  return (
    <>
      {onAbrir !== undefined && <DropdownItem onSelect={onAbrir}>Abrir</DropdownItem>}
      <DropdownItem onSelect={() => onPedir({ tipo: 'criar', paiId: pasta.id })}>
        Nova subpasta
      </DropdownItem>
      {!sistema && (
        <>
          <DropdownItem onSelect={() => onPedir({ tipo: 'renomear', pasta })}>
            Renomear
          </DropdownItem>
          <DropdownItem onSelect={() => onPedir({ tipo: 'mover', pasta })}>Mover</DropdownItem>
          <DropdownItem danger onSelect={() => onPedir({ tipo: 'excluir', pasta })}>
            Excluir
          </DropdownItem>
        </>
      )}
    </>
  );
}

/** O menu de cada pasta, aqui e na barra lateral. */
export function AcoesDaPasta({
  pasta,
  onPedir,
  extra,
}: {
  pasta: Pasta;
  onPedir: (p: PedidoDePasta) => void;
  /** Itens a mais no fim, como "Gerenciar pastas" na barra lateral. */
  extra?: React.ReactNode;
}) {
  return (
    <Dropdown>
      <DropdownTrigger asChild>
        <button
          type="button"
          aria-label={`Ações da pasta ${pasta.name}`}
          className="flex size-7 toque:size-10 shrink-0 cursor-pointer items-center justify-center rounded-md text-tertiary hover:bg-hover hover:text-primary"
        >
          <EllipsisVertical size={16} strokeWidth={1.5} aria-hidden="true" />
        </button>
      </DropdownTrigger>
      <DropdownContent align="end">
        <ItensDaPasta pasta={pasta} onPedir={onPedir} />
        {extra}
      </DropdownContent>
    </Dropdown>
  );
}
